import type { Entry } from '../../shared/types.js';
import { scopeLabel } from '../lib/scope.js';

interface Props {
  entries: Entry[];
  onOpen: (id: string) => void;
}

export function EntryList({ entries, onOpen }: Props) {
  if (entries.length === 0) {
    return <p className="empty">No entries match. Log one above — title is all you need.</p>;
  }
  return (
    <ul className="entry-list">
      {entries.map((e) => (
        <li key={e.id}>
          <button type="button" className="entry-card" onClick={() => onOpen(e.id)}>
            <div className="entry-card-head">
              <span className="entry-title">{e.title}</span>
              <span className={`badge status-${e.status}`}>{e.status}</span>
            </div>
            <div className="entry-card-meta">
              <span>{e.occurred_on}</span>
              {e.scope === 'stretch' && <span className="badge scope">{scopeLabel(e.scope)}</span>}
              {e.project && <span className="chip">{e.project}</span>}
            </div>
            {e.impact && <p className="entry-impact">{e.impact}</p>}
          </button>
        </li>
      ))}
    </ul>
  );
}
